import { render } from "./averagePricesDialog.vue?vue&type=template&id=41445ac4"
import script from "./averagePricesDialog.vue?vue&type=script&lang=js"
export * from "./averagePricesDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__